export enum RoleAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_ROLE_LIST = "ADD_ROLE_LIST",
    UPDATE_ROLE_LIST = "UPDATE_ROLE_LIST",
    UPDATE_ROLE_SEARCH_REQ = "UPDATE_ROLE_SEARCH_REQ",
    SET_UPDATE_ROLE = "SET_UPDATE_ROLE",
    UPDATE_PERMISSION_LIST = "UPDATE_PERMISSION_LIST",
}